import React from "react";
import { cn } from "../../../lib/utils";
import InfoModal from "../info-modal";

interface OptionInfoProps {
  option: any;
  position?: "top-left" | "top-right" | "bottom-right";
  className?: string;
}

export const OptionInfo: React.FC<OptionInfoProps> = ({
  option,
  position = "top-left",
  className,
}) => {
  const positionClasses = {
    "top-left": "top-2 left-2",
    "top-right": "top-2 right-2",
    "bottom-right": "bottom-2 right-2",
  };

  return (
    <div className={cn("absolute", positionClasses[position], className)}>
      <InfoModal option={option} />
    </div>
  );
};
